import { SITE } from "@/data/site";

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.name,
  legalName: SITE.legalName,
  url: SITE.url,
  "@id": `${SITE.url}/#organization`,
  logo: SITE.ogImage,
  image: SITE.ogImage,
  email: SITE.email,
  telephone: "+1-657-768-6189",
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE.url}/#website`,
  name: SITE.name,
  url: SITE.url,
  publisher: { "@id": `${SITE.url}/#organization` },
});

export const localBusinessSchema = (extra = {}) => ({
  "@context": "https://schema.org",
  "@type": "AutomotiveBusiness",
  "@id": `${SITE.url}/#business`,
  name: SITE.name,
  image: SITE.ogImage,
  url: SITE.url,
  telephone: "+1-657-768-6189",
  email: SITE.email,
  openingHours: "Mo-Sa 07:00-20:00",
  areaServed: SITE.areaServed.map((a) => ({ "@type": "AdministrativeArea", name: `${a}, California` })),
  serviceType: ["Mobile Car VIN Verification", "SUV VIN Verification", "Pickup Truck VIN Verification", "Out-of-State Car VIN Verification", "Classic Car VIN Verification", "Motorcycle VIN Verification", "Trailer VIN Verification", "RV and Motorhome VIN Verification", "Commercial Vehicle VIN Verification", "Fleet VIN Verification", "Licensed Vehicle Verifier", "DMV REG 31"],
  parentOrganization: { "@id": `${SITE.url}/#organization` },
  ...extra,
});

export const serviceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  url: `${SITE.url}${path}`,
  provider: { "@id": `${SITE.url}/#business` },
  areaServed: SITE.areaServed.map((a) => ({ "@type": "AdministrativeArea", name: `${a}, California` })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE.url}${it.path}`,
  })),
});

export const articleSchema = ({ title, description, path, date }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  datePublished: date,
  author: { "@type": "Organization", name: SITE.name },
  publisher: { "@type": "Organization", name: SITE.name, logo: { "@type": "ImageObject", url: SITE.ogImage } },
  mainEntityOfPage: `${SITE.url}${path}`,
});
